/**
 * Відповідність полів модуля «Звіти й аналітика» поняттям довідника (підключається в features/knowledge/fieldTerms.ts).
 * Значок «?» з’являється, лише якщо поняття є в словнику сервера.
 */
export const REPORTS_FIELD_TERMS: Readonly<Record<string, string>> = {
  'reports.metric.statistic': 'Статистика',
  'reports.metric.kpi': 'КРІ',
  'reports.qualityStandard': 'Стандарт якості',
  'reports.netEarnings': 'ЧЗ',
  'reports.rule100': 'Правило 100 USD',
};
